<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="save()"
	[nzOkLoading]="isConfirmLoading"
    [nzOkDisabled]="form.invalid || usernameStatus !== 'available'"
	[nzCancelDisabled]="isConfirmLoading"
    [nzMaskClosable]="!isConfirmLoading"
    [nzKeyboard]="!isConfirmLoading"
    [nzClosable]="!isConfirmLoading"
    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="600"
    [nzFooter]="modalFooter">

    <ng-template #modalTitle>
        Edit {{ user?.name }} {{ user?.surname }}
    </ng-template>

    <ng-container *nzModalContent>
        @if (!canEdit) {
            <app-unauthorized-access-edit-warning></app-unauthorized-access-edit-warning>
        }
        <form nz-form [formGroup]="form" [nzLayout]="'horizontal'">
            
            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Username</nz-form-label>
                
                <nz-form-control [nzSm]="18" [nzXs]="24" 
                    nzHasFeedback
                    [nzValidateStatus]="currentValidateStatus"
                    [nzErrorTip]="usernameErrorTpl"
                    [nzValidatingTip]="'Checking availability...'">
                    
                    <input nz-input formControlName="newUsername" placeholder="Username" />
                    
                    <ng-template #usernameErrorTpl>
                        @if (form.get('newUsername')?.errors?.['required']) {
                            Username is required.
                        } @else if (form.get('newUsername')?.errors?.['minlength']) {
                            Minimum 5 characters.
                        } @else if (form.get('newUsername')?.errors?.['maxlength']) {
                            Maximum 20 characters.
                        } @else if (form.get('newUsername')?.errors?.['usernameTaken']) {
                            Username is already taken.
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Name</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Name is required (2-20 chars).">
                    <input nz-input formControlName="name" placeholder="Name" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Surname</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Surname is required (3-20 chars).">
                    <input nz-input formControlName="surname" placeholder="Surname" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24">Email</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" [nzErrorTip]="emailErrorTpl">
                    <input nz-input formControlName="email" placeholder="Email" />
                    <ng-template #emailErrorTpl>
                        @if (form.get('email')?.errors?.['email']) {
                            Please enter a valid email address.
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>Status</nz-form-label>
                <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Status is required.">
                    <nz-select formControlName="status" nzPlaceHolder="Select Status" style="width: 100%;">
                        <nz-option *ngFor="let s of statuses" [nzValue]="s" [nzLabel]="s"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>

    <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Close</button>
        @if (canEdit) {
            <button nz-button nzType="primary" [nzLoading]="isConfirmLoading" (click)="save()">Save</button>
        }
    </ng-template>

</nz-modal>